module.exports = __webpack_public_path__ + "static/media/YF32_1.0897b528.jpg";